import React from "react";
import { Zap } from "lucide-react"; // Asegúrate de importar los iconos correctamente

interface ProductDetailsProps {
  title: string;
  description: string;
}

const ProductDetails: React.FC<ProductDetailsProps> = ({ title, description }) => {
  return (
    <div className="pb-8 border-b border-gray-200">
      <div className="flex items-center gap-3 mb-4">
        <Zap className="w-8 h-8 text-navy-900" />
        <span className="text-sm font-semibold text-navy-900 bg-navy-50 px-3 py-1 rounded-full">
          Enterprise-Grade Solution
        </span>
      </div>
      <h1 className="text-3xl font-bold text-navy-900 leading-tight bg-gradient-to-r from-navy-900 to-blue-900 bg-clip-text text-transparent">
        {title}
      </h1>
      <p className="mt-6 text-lg text-gray-600 leading-relaxed font-medium">
        {description}
      </p>
    </div>
  );
};

export default ProductDetails;
